import React from 'react';
import ReactDOM from 'react-dom';
import DynamicHome from './dynamic-home/_index.jsx';
import '../scss/styles.scss';

// Main application
ReactDOM.render(
	<DynamicHome/>,
	document.getElementById('react-root')
);
